const fixedAriaLabels = Object.freeze({
    close: '关闭',
    'close drawer': '关闭抽屉',
    'close dialog': '关闭弹窗',
})

const observerKey = '__qcyyElementUiA11yObserver__'

export function chineseAriaLabel(label) {
    const text = String(label || '').trim()
    if (!text) return text
    const normalizedText = text.toLowerCase()
    if (fixedAriaLabels[normalizedText]) return fixedAriaLabels[normalizedText]

    const closeWithTitle = /^close\s+(.+)$/i.exec(text)
    if (!closeWithTitle) return text
    const title = closeWithTitle[1].trim()
    // 中文标题保留上下文；英文或未知组件标题使用固定中文，避免辅助阅读继续朗读英文。
    return /[\u3400-\u9fff]/.test(title) ? `关闭${title}` : '关闭弹窗'
}

export function localizeElementUiA11y(root) {
    if (!root) return
    const elements = []
    if (root.nodeType === 1 && root.hasAttribute('aria-label')) elements.push(root)
    if (typeof root.querySelectorAll === 'function') elements.push(...root.querySelectorAll('[aria-label]'))

    elements.forEach((element) => {
        const current = element.getAttribute('aria-label')
        const localized = chineseAriaLabel(current)
        if (localized && localized !== current) element.setAttribute('aria-label', localized)
    })
}

export function installElementUiA11yLocalization() {
    if (typeof document === 'undefined' || typeof MutationObserver === 'undefined') return
    if (document[observerKey]) return

    const start = () => {
        if (document[observerKey]) return
        // Element UI 2 的弹窗和抽屉关闭按钮内置英文辅助文本，统一在渲染后改为中文。
        localizeElementUiA11y(document)
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes') {
                    localizeElementUiA11y(mutation.target)
                    return
                }
                mutation.addedNodes.forEach((node) => localizeElementUiA11y(node))
            })
        })
        Object.defineProperty(document, observerKey, {value: observer, configurable: true})
        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['aria-label'],
        })
    }

    if (document.body) start()
    else document.addEventListener('DOMContentLoaded', start, {once: true})
}
